import { message } from 'antd'
import http from '../http'

const getTags = (size = 10, page = 1, type, category, search) => {
  return dispatch => {
    return uGetTags({size, page, type, category, search})
      .then(res => {
        search && dispatch({
          type: 'GET_SEARCH_TAGS',
          searchTags: res.tags,
          searchTagCount: res.count
        })
        category === 'following' ? dispatch({
          type: 'GET_FOLLOW_TAGS',
          followTags: res.tags,
          followTagCount: res.count
        }) : dispatch({
          type: 'GET_TAGS',
          tags: res.tags,
          count: res.count
        })
        return 'success';
      })
      .catch(err => {
        // message.error(err.response?.data?.message?.[0])
        console.error(err);
        return 'error';
      })
  }
}
const uGetTags = ({size = 10, page = 1, type, category, search}) => {
  const t = type ? `&type=${type}` : ''
  const c = category ? `&category=${category}` : ''
  const s = search ? `&search=${search}` : ''
  return http
    .get(`/tags?size=${size}&page=${page}` + t + c + s)
    .then(res => {
      return res?.data?.data;
    });
}



const followTag = (tagId) => {
  return dispatch => {
    return http
      .put(`/tags/${tagId}/follows`)
      .then(() => {
        message.success("Tag followed successfully")
        dispatch(getTags(100, 1, 'keyword', 'following'))
        return true
      })
      .catch(err => {
        message.error(err.response?.data.message[0])
        console.error(err)
      })
  }
}

const unFollowTag = (tagId) => {
  return dispatch => {
    return http
      .delete(`/tags/${tagId}/follows`)
      .then(() => {
        message.success("Tag unfollowed successfully")
        dispatch(getTags(100, 1, 'keyword', 'following'))
        return true
      })
      .catch(err => {
        message.error(err.response?.data.message[0])
        console.error(err)
      })
  }
}

export { getTags, followTag, unFollowTag, uGetTags  }

